export default "__VITE_ASSET__CBMGVa46__"